import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/aos/dist/aos.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/yet-another-react-lightbox/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"600\",\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["FacebookPixel"] */ "/codebuild/output/src304228501/src/landing/src/components/FacebookPixel/FacebookPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src304228501/src/landing/src/components/Providers/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/src/styles/globals.css");
